{
  "laser": {
    "type": "oscillator",
    "oscillatorType": "sawtooth",
    "startFreq": 880,
    "endFreq": 110,
    "duration": 0.12,
    "gain": 0.3,
    "ramp": "exponential"
  },
  "explosion": {
    "type": "noise",
    "noiseDuration": 0.45,
    "filterStartFreq": 120,
    "filterEndFreq": 20,
    "duration": 0.45,
    "gain": 0.6,
    "oscillatorType": "triangle",
    "startFreq": 120,
    "endFreq": 20,
    "ramp": "exponential"
  },
  "doorSlide": {
    "type": "oscillator",
    "oscillatorType": "sine",
    "startFreq": 160,
    "endFreq": 320,
    "duration": 0.35,
    "rampDuration": 0.3,
    "gain": 0.15,
    "ramp": "linear"
  },
  "elevatorHum": {
    "type": "fm",
    "frequency": 80,
    "modFreq": 5,
    "modDepth": 20,
    "duration": 1.0,
    "gain": 0.2
  },
  "pickupChime": {
    "type": "arpeggio",
    "oscillatorType": "sine",
    "frequencies": [523.25, 659.25, 783.99, 1046.5],
    "noteDuration": 0.08,
    "duration": 0.4,
    "gain": 0.25
  },
  "hitBeep": {
    "type": "oscillator",
    "oscillatorType": "sine",
    "freq": 800,
    "startFreq": 800,
    "endFreq": 800,
    "duration": 0.05,
    "gain": 0.2
  },
  "click": {
    "type": "oscillator",
    "oscillatorType": "triangle",
    "freq": 1200,
    "startFreq": 1200,
    "endFreq": 400,
    "duration": 0.03,
    "gain": 0.25,
    "ramp": "exponential"
  },
  "scannerChirp": {
    "type": "oscillator",
    "oscillatorType": "sine",
    "startFreq": 1400,
    "endFreq": 2400,
    "rampDuration": 0.08,
    "duration": 0.1,
    "gain": 0.35,
    "ramp": "exponential"
  },
  "impact": {
    "type": "oscillator",
    "oscillatorType": "triangle",
    "startFreq": 300,
    "endFreq": 50,
    "duration": 0.08,
    "gain": 0.3,
    "ramp": "exponential"
  },
  "playerHurt": {
    "type": "oscillator",
    "oscillatorType": "sawtooth",
    "startFreq": 180,
    "endFreq": 70,
    "duration": 0.2,
    "gain": 0.4,
    "ramp": "exponential"
  },
  "weapons": {
    "basic2p": {
      "type": "oscillator",
      "oscillatorType": "sawtooth",
      "startFreq": 880,
      "endFreq": 110,
      "duration": 0.12,
      "gain": 0.3,
      "ramp": "exponential"
    },
    "spread1p": {
      "type": "oscillator",
      "oscillatorType": "sawtooth",
      "startFreq": 880,
      "endFreq": 110,
      "duration": 0.12,
      "gain": 0.3,
      "ramp": "exponential"
    },
    "blade": {
      "type": "oscillator",
      "oscillatorType": "triangle",
      "startFreq": 220,
      "endFreq": 440,
      "rampDuration": 0.08,
      "duration": 0.15,
      "gain": 0.4,
      "ramp": "linear"
    },
    "plasma": {
      "type": "oscillator",
      "oscillatorType": "square",
      "startFreq": 240,
      "endFreq": 40,
      "duration": 0.3,
      "gain": 0.5,
      "ramp": "exponential"
    },
    "cannon1p": {
      "type": "oscillator",
      "oscillatorType": "square",
      "startFreq": 240,
      "endFreq": 40,
      "duration": 0.3,
      "gain": 0.5,
      "ramp": "exponential"
    },
    "rail": {
      "type": "oscillator",
      "oscillatorType": "sawtooth",
      "startFreq": 1800,
      "endFreq": 60,
      "duration": 0.25,
      "gain": 0.6,
      "ramp": "exponential"
    },
    "default": {
      "type": "oscillator",
      "oscillatorType": "sine",
      "startFreq": 440,
      "endFreq": 80,
      "duration": 0.2,
      "gain": 0.3,
      "ramp": "exponential"
    }
  }
}
